/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
// Component: ALhfiVPnGgY_
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ModuleNavLogo from "../../ModuleNavLogo"; // plasmic-import: 61rgnG3wL1HW/component
import ModuleNav from "../../ModuleNav"; // plasmic-import: 9QJHZ6j77LRS/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectcss
import sty from "./PlasmicSideNav.module.css"; // plasmic-import: ALhfiVPnGgY_/css

createPlasmicElementProxy;

export const PlasmicSideNav__VariantProps = new Array();

export const PlasmicSideNav__ArgProps = new Array("logo", "backButton");

const $$ = {};

function PlasmicSideNav__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"sidenav"}
      data-plasmic-override={overrides.sidenav}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.sidenav
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        <div
          data-plasmic-name={"moduleNavTop"}
          data-plasmic-override={overrides.moduleNavTop}
          className={classNames(projectcss.all, sty.moduleNavTop)}
        >
          {renderPlasmicSlot({
            defaultContents: (
              <ModuleNavLogo
                className={classNames(
                  "__wab_instance",
                  sty.moduleNavLogo__hsStR
                )}
              />
            ),

            value: args.logo
          })}
        </div>
        <div
          data-plasmic-name={"buttons"}
          data-plasmic-override={overrides.buttons}
          className={classNames(projectcss.all, sty.buttons)}
        />

        <div
          data-plasmic-name={"moduleNavBottom"}
          data-plasmic-override={overrides.moduleNavBottom}
          className={classNames(projectcss.all, sty.moduleNavBottom)}
        >
          {renderPlasmicSlot({
            defaultContents: (
              <ModuleNav
                className={classNames("__wab_instance", sty.moduleNav__blt7K)}
              />
            ),

            value: args.backButton
          })}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  sidenav: ["sidenav", "freeBox", "moduleNavTop", "buttons", "moduleNavBottom"],
  freeBox: ["freeBox", "moduleNavTop", "buttons", "moduleNavBottom"],
  moduleNavTop: ["moduleNavTop"],
  buttons: ["buttons"],
  moduleNavBottom: ["moduleNavBottom"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSideNav__ArgProps,
          internalVariantPropNames: PlasmicSideNav__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSideNav__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "sidenav") {
    func.displayName = "PlasmicSideNav";
  } else {
    func.displayName = `PlasmicSideNav.${nodeName}`;
  }
  return func;
}

export const PlasmicSideNav = Object.assign(
  // Top-level PlasmicSideNav renders the root element
  makeNodeComponent("sidenav"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    moduleNavTop: makeNodeComponent("moduleNavTop"),
    buttons: makeNodeComponent("buttons"),
    moduleNavBottom: makeNodeComponent("moduleNavBottom"),
    // Metadata about props expected for PlasmicSideNav
    internalVariantProps: PlasmicSideNav__VariantProps,
    internalArgProps: PlasmicSideNav__ArgProps
  }
);

export default PlasmicSideNav;
/* prettier-ignore-end */
